<div class="content-loaf">
  <h2>空床情報参照</h2>
  <hr />

  <div class="row content-block">
    <div class="col-12 col-md-8 col-lg-9">
      <p>
        このシステムは、わたしたちが診ている患者様のために、そして佐伯地区医師会に所属される診療所と病院の連携、病院同士の連携をよりスムーズにしていくために、
        各医療機関等のご理解とご協力のもとに構築したものです。
        昼夜を問わず、常に私たちにとって心強い地域基幹病院であるJA広島総合病院の空床情報を組み入れることは現時点では想定していません。<br />
        この空床情報で空床があると必ずすぐあらゆる患者様を受け入れることができるという意味ではありません。
        病棟の種類により受け入れることができる病態や条件が異なりますので、病棟の種類について詳しくは説明ボタンを押してご参照ください。
        また休日・夜間において受け入れることができることを意味している訳ではありません。
        基本的に、検査や対応がしっかりできるスタッフがそろう診療時間内での運用を想定しています。
        ベッドを持つ各医療機関の状況がそれぞれありますので、ご参照される皆様方におかれましては、ご理解とご協力をよろしくお願い申し上げます。
        状況は日々変わり、ここに記載されている状況と異なる場合がございます。詳しくはお電話にてお問い合わせください。
      </p>

      <div class="text-right">
        ２０１８年１０月<br />
        佐伯地区医師会 理事 野村 陽平
      </div>
    </div>

    <div class="col-12 col-md-4 col-lg-3">
      <a class="btn btn-primary btn-primary-gradient" href="/Pdf/VacantBedsInfo/AboutWard.pdf" target="_blank">病棟について詳しく</a>
    </div>

    <div class="col-12">
      <div name="city" *ngFor="let cityInfo of cityInfoes">
        <div *ngIf="cityInfo.institutionInfoes.length > 0">
          <div class="row">
            <div class="col-6">
              <h3><i class="fa fa-chevron-right"></i>{{cityInfo.name}}</h3>
            </div>

            <div class="col-6 text-right" style="margin-top: 45px;">２０２０年１０月８日改定</div>
          </div>

          <!-- パソコン用表示 -->
          <div class="content-block d-none d-lg-block">
            <table class="table table-default reference-table table-bordered">
              <thead>
                <tr>
                  <th style="min-width: 200px;">施設名</th>
                  <th style="min-width: 180px;">病棟</th>
                  <th style="min-width: 70px;">男 (床)</th>
                  <th style="min-width: 70px;">女 (床)</th>
                  <th>備考</th>
                  <th style="min-width: 120px;">更新日時</th>
                </tr>
              </thead>

              <tbody name="institution" *ngFor="let institutionInfo of cityInfo.institutionInfoes">
                <tr name="ward" *ngIf="institutionInfo.wards.length > 0">
                  <td class="vertical-middle" [attr.rowspan]="institutionInfo.wards.length">
                    <h5>{{institutionInfo.institutionName}}</h5>
                    <p>
                      <span name="tel">電話：{{institutionInfo.tel}}</span><br />
                      <span name="fax">FAX ：{{institutionInfo.fax}}</span><br />
                      <span name="address">住所：{{institutionInfo.address}}</span>
                    </p>
                    <p name="comment">{{institutionInfo.comment}}</p>
                  </td>
                  <!-- 1つ目の病棟はべた書き -->
                  <td name="ward-name" class="vertical-middle">{{institutionInfo.wards[0].name}}</td>
                  <td name="male-count" class="text-center vertical-middle">{{institutionInfo.wards[0].maleCount}}</td>
                  <td name="female-count" class="text-center vertical-middle">{{institutionInfo.wards[0].femaleCount}}</td>
                  <td name="ward-comment" class="vertical-middle">{{institutionInfo.wards[0].comment}}</td>
                  <td class="text-center vertical-middle" [attr.rowspan]="institutionInfo.wards.length">
                    <span name="update-date">{{institutionInfo.updateTime | date: 'yyyy/MM/dd'}}</span><br />
                    <span name="update-time">{{institutionInfo.updateTime | date: 'HH:mm'}}</span>
                  </td>
                </tr>

                <!-- 2つ目以降の病棟をngForで回す -->
                <tr name="ward" *ngFor="let ward of institutionInfo.wards.slice(1)">
                  <td name="ward-name" class="vertical-middle">{{ward.name}}</td>
                  <td name="male-count" class="text-center vertical-middle">{{ward.maleCount}}</td>
                  <td name="female-count" class="text-center vertical-middle">{{ward.femaleCount}}</td>
                  <td name="ward-comment" class="vertical-middle">{{ward.comment}}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- スマホ用表示 -->
          <div class="content-block d-lg-none" *ngFor="let institutionInfo of cityInfo.institutionInfoes">
            <div class="row institution-content" *ngIf="institutionInfo.wards.length > 0">
              <div class="col-12 col-sm-6">
                <h4>{{institutionInfo.institutionName}}</h4>
              </div>

              <div class="col-12 col-sm-6 text-right">
                更新日時 : {{institutionInfo.updateTime | date: 'yyyy/MM/dd HH:mm'}}
              </div>

              <div class="col-12 institution-separator">
                <hr />
              </div>

              <div class="col-12 institution-remarks">
                <p>
                  電話：<a href="tel:{{institutionInfo.tel}}">{{institutionInfo.tel}}</a><br />
                  FAX ：{{institutionInfo.fax}}<br />
                  住所：{{institutionInfo.address}}<br />
                  {{institutionInfo.comment}}
                </p>
              </div>

              <div name="ward" class="col-12" *ngFor="let ward of institutionInfo.wards">
                <table class="table table-default reference-table table-bordered">
                  <thead>
                    <tr>
                      <th colspan="2" class="text-center">{{ward.name}}</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td class="text-center" style="width: 80px;">男 (床)</td>
                      <td class="text-center">{{ward.maleCount}}</td>
                    </tr>
                    <tr>
                      <td class="text-center">女 (床)</td>
                      <td class="text-center">{{ward.femaleCount}}</td>
                    </tr>
                    <tr>
                      <td class="text-center vertical-middle">備考</td>
                      <td>{{ward.comment}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
